import GujaratiMonth from "../../data/gujaratiMonth.json";
export const GujaratiMonths = (paramsObj) => {
  return GujaratiMonth;
};
